import { DataModel } from "common/models/utility-models/base-model";

export class LocationModel extends DataModel {
    city_name:any=''
}